import { Link, type LinkProps } from 'react-router-dom'
import { cn } from '@/lib/utils'

interface TextLinkProps extends LinkProps {
  underline?: boolean
  external?: boolean
}

export function TextLink({
  className,
  underline = false,
  external,
  children,
  ...props
}: TextLinkProps) {
  const classes = cn(underline ? 'link-gold-underline' : 'link-gold', className)

  if (external) {
    return (
      <a
        href={props.to as string}
        target="_blank"
        rel="noreferrer"
        className={classes}
      >
        {children}
      </a>
    )
  }

  return (
    <Link className={classes} {...props}>
      {children}
    </Link>
  )
}
